import { Eye, MousePointerClick, Search, Users, Info } from "lucide-react";

const CARDS = [
  ["search_appearances", "Appeared in GP searches", Search, "The number of times your profile appeared in a GP directory result."],
  ["profile_views", "Profile views", Eye, "The number of times a GP opened your full directory profile."],
  ["selected_for_referral", "Selected for referral", MousePointerClick, "The number of times a GP chose you and confirmed they would continue with one of the referral options."],
  ["unique_gp_practices", "Unique GP practices", Users, "The number of different GP practices that selected you for referral."],
];

export const ClinicianInsights = ({ insights, combined = false }) => {
  if (!insights?.enabled) return null;
  const totals = insights.totals || {};
  return (
    <section className="rounded-lg border border-slate-200 bg-white p-5" data-testid={combined ? "clinic-insights" : "clinician-insights"}>
      <div>
        <h2 className="font-heading text-lg font-semibold text-slate-900">Insights</h2>
        <p className="mt-1 text-sm text-slate-500">{combined ? "Combined activity across your clinic team." : "How GP practices are engaging with your availability and profile."} No patient information is recorded.</p>
      </div>
      <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {CARDS.map(([key, label, Icon, help]) => (
          <div key={key} className="rounded-md border border-slate-200 bg-slate-50 p-4">
            <div className="flex items-start justify-between gap-2 text-slate-500">
              <Icon className="h-4 w-4" />
              <span title={help} aria-label={help} className="cursor-help text-slate-400"><Info className="h-4 w-4" /></span>
            </div>
            <p className="mt-3 font-heading text-2xl font-semibold text-slate-900" data-testid={`insight-${key}`}>{totals[key] || 0}</p>
            <p className="mt-1 text-xs font-medium text-slate-600">{label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
